
export function newsFunc() {
  const filterButton = document.getElementById('js-filter');
  const confirmButton = document.getElementById('js-confirm');
  const asideElement = document.getElementById('js-aside');
  const listItems = document.querySelectorAll('.p-news__side__item');

  filterButton.addEventListener('click', function() {
    // #js-asideにshowクラスを追加
    asideElement.classList.add('show');
  });

  confirmButton.addEventListener('click', function() {
    // #js-asideにshowクラスを追加
    asideElement.classList.remove('show');
  });

  listItems.forEach(item => {
      item.addEventListener('click', function() {
          this.classList.toggle('active');
      });
  });
}